/**
 * 运价输入审核
 */
export const CHECK_FIELD = ['carrier', 'frequency', 'pol', 'pod', 'region']
export class AirApproveSettings {
  constructor(data) {
    this.polMap = {}
    this.podMap = {}
    this.pol = 'ALLRG'
    this.pod = 'ALLRG'
    this.region = 'ALLRG'
    this.carrier = 0
    this.frequency = 0
    this.t1M = 0
    this.t1N = 0
    this.t1P45 = 0
    this.t1P100 = 0
    this.t1P300 = 0
    this.t1P500 = 0
    this.t1P1000 = 0
    this.t2M = 0
    this.t2N = 0
    this.t2P45 = 0
    this.t2P100 = 0
    this.t2P300 = 0
    this.t2P500 = 0
    this.t2P1000 = 0
    this.t3M = 0
    this.t3N = 0
    this.t3P45 = 0
    this.t3P100 = 0
    this.t3P300 = 0
    this.t3P500 = 0
    this.t3P1000 = 0
    this.setData(data)
  }
  setData(data) {
    if (data) {
      for (const item in data) {
        if (data.hasOwnProperty(item)) {
          this[item] = data[item]
        }
      }
    }
  }
  isOverlap(other) {
    if (this.carrier !== other.carrier || this.frequency !== other.frequency || this.pol !== other.pol || this.pod !== other.pod || this.region !== other.region) {
      return false
    } else {
      return true
    }
  }
}
